<template>
  <v-row>
    <v-col cols="12" v-if="!loading">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Auditorio:</h3>
          </v-col>

          <v-col cols="12" xl="12" md="12" sm="12" xs="12">
            <v-text-field
              ref="name"
              v-model="name"
              outlined
              :maxlength="75"
              :counter="75"
              :rules="[v => (v || '' ).length <= 74 || 'El nombre no debe tener mas de 75 caracteres']"
              label="Nombre del auditorio"
              required
            ></v-text-field>
          </v-col>

          <v-col class="pl-4" cols="12">
            <h3 class="font-weight-regular">Estado:</h3>
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="is_visible"
              :label="(is_visible)?'Auditorio visible':'Auditorio oculto'"
            ></v-switch>
          </v-col> 


        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined>
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Banner superior:</h3>
          </v-col>
          
          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!banner"
              v-model="banner"
              :rules="rules"
              @change="onBannerChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Banner"
              :messages="['Para una mejor visualización, usar un foto cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="banner">
              <v-img
                cover
                :src="url_banner"
                class="grey lighten-2"
                height="120px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteBanner()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>

          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!banner_sm"
              v-model="banner_sm"
              :rules="rules"
              @change="onBannerSMChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Banner SM (imagen recomendada de 960x120)"
              :messages="['Para una mejor visualización, usar un foto cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              v-if="banner_sm"
              width="440px">
              <v-img
                cover
                :src="url_banner_sm"
                class="grey lighten-2"
                height="120px"
                max-width="960px"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteBannerSM()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>

        </v-row>
      </v-sheet>

      <v-sheet
        class="mt-4"
        width="100%"
        outlined>
        <v-row class="pa-4">
          <v-col cols="12">
            <h3 class="font-weight-regular">Miniatura para la espera:</h3>
          </v-col>
          
          <v-col cols="12">
            <v-file-input
              outlined
              v-if="!miniature"
              v-model="miniature"
              :rules="rules"
              @change="onMiniatureChange"
              accept="image/png, image/jpeg, image/bmp"
              prepend-icon="mdi-camera"
              label="Miniatura"
              :messages="['Para una mejor visualización, usar un foto cuadrado, y si tiene transparencia asegurarse de que sea formato PNG.']"
            ></v-file-input>

            <v-card
              width="520"
              v-if="miniature">
              <v-img
                :aspect-ratio="16/9"
                cover
                :src="url_miniature"
                class="grey lighten-2"
              >
              </v-img>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn icon>
                  <v-icon color="black" @click="deleteMiniature()">mdi-delete</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card> 

          </v-col>
        </v-row>
      </v-sheet>

    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'auditoriumsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-btn
        depressed
        :loading="loading_btn"
        :disabled="!name"
        color="primary"
        @click="updateAuditorium()"
        >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Guardar
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'newEvaluatorEdition',

    data: () => ({
      loading:true,
      loading_btn: false,
      loading_update:false,
      
      
      auditorium:[],
      name:null,
      is_visible:false,

      banner:null,
      url_banner:null,

      banner_sm:null,
      url_banner_sm:null,

      miniature:null,
      url_miniature:null,

      rules: [
        (value) =>
          !value ||
          value.size < 2 ||
          "El archivo es demaciado grande",
      ],

      edition_id: null
    }),

    methods:{
      async getAuditorium(){
        await axios.get('admin/editions/'+this.edition_id+'/auditoriums/'+this.auditorium_id ).then(response =>{
          this.auditorium = response.data.data.auditorium
          this.name = this.auditorium.name
          this.is_visible = this.auditorium.is_visible

          this.banner = this.auditorium.banner

          if(this.auditorium.banner){
            this.url_banner = APP_URL + this.auditorium.banner
          }

          this.banner_sm = this.auditorium.banner_sm
          if(this.auditorium.banner_sm){
            this.url_banner_sm = APP_URL + this.auditorium.banner_sm
          }

          this.miniature = this.auditorium.miniature
          if(this.auditorium.miniature){
            this.url_miniature = APP_URL + this.auditorium.miniature
          }

          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      async updateAuditorium(){
        this.loading_btn = true

        let formData= new FormData()
        formData.append('name', this.name)
        formData.append('is_visible', this.is_visible)
        formData.append('banner', this.banner)
        formData.append('banner_sm', this.banner_sm)
        formData.append('miniature', this.miniature)

        try {
          await axios({
            method: 'post',
            url: 'admin/editions/'+this.edition_id+'/auditoriums/'+this.auditorium_id,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then( () =>{
            this.dialog_new = false
            this.loading_btn = false
            this.loading = true
            this.$router.push({ name: 'auditoriumsEdition', params: { edition_id: this.edition_id } })
          })
        } catch (error) {
          this.dialog_new_edition = false
          console.log('Response: ')
          console.error(error.response.data);
        }
      },

      onBannerChange() {
        this.url_banner = URL.createObjectURL(this.banner);
      },

      deleteBanner(){
        this.banner=null
        this.url_banner=null
      },

      onBannerSMChange() {
        this.url_banner_sm = URL.createObjectURL(this.banner_sm);
      },

      deleteBannerSM(){
        this.banner_sm=null
        this.url_banner_sm=null
      },

      onMiniatureChange() {
        this.url_miniature = URL.createObjectURL(this.miniature);
      },

      deleteMiniature(){
        this.miniature=null
        this.url_miniature=null
      }

    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.auditorium_id = this.$route.params.auditorium_id
      this.getAuditorium()
    },
  }
</script>
